export default "__VITE_ASSET__cbe87168__"